import { Component, OnInit,  } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { DocumentManagementMasterService } from 'src/app/services/document-management-master.service';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
import { environment } from 'src/environments/environment';
import { PowerofattorneyService } from 'src/app/services/powerofattorney.service';

declare var $: any;
@Component({
  selector: 'app-powerofattorney',
  templateUrl: './powerofattorney.component.html',
  styleUrls: ['./powerofattorney.component.css']
})
export class PowerofattorneyComponent implements OnInit {

  poaForm: FormGroup;
  poaList: any = [];
  filesToUpload: Array<File>;
  fileExtension: boolean = true;
  FileOrignalName: any;
  changedName: any;
  editPoaId: any;
  dobminPower: any;
  datewithdrawalPower: any;
  addBtn = true;
  fileAvailable = false;
  poaFileName: any;
  public environmentSettings: any;
  public downloadAllLink: string = "documentManagement/downloadSingleFileOnID/";
  documentManagementID: any;
  canRevert: boolean;
  disabledOnclick: boolean;
  token: any = localStorage.getItem('token')

  constructor(private PowerofattorneyService: PowerofattorneyService, private alert: AlertComponent, public commonFunction:CommonFunction,
    private documentManagementMasterService: DocumentManagementMasterService, private customValidation: CustomValidation,
    private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {

    // this.token = localStorage.getItem('token');
    this.poaForm = new FormGroup({
      paticularsofPower: new FormControl(''),
      namedesgnPower: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z. ,'][a-zA-Z. ,']*$"), this.customValidation.noWhitespaceValidator]),
      dobminPower: new FormControl('', []),
      commonsealaffixedPower: new FormControl(''),
      datewithdrawalPower: new FormControl('', []),
      fileName: new FormControl('', []),
      remarks: new FormControl('', [])
    })

    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
        this.editPoaId = params['particularId'];
        this.getPoaById(this.editPoaId);
      }
    })
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;

    }
    return null;
  }
  back(){
    
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['powerofattorneylist']  } }],
      { relativeTo: this.activatedRoute.parent });
      }
  fileChangeEvent($event) {
    console.log("this.filesToUpload", this.filesToUpload)
    var checkfile = this.commonFunction.checkFileExtension($event);
    if(checkfile){
      this.filesToUpload = <Array<File>>$event.target.files;
     this.fileExtension = true;
     this.canRevert = false;
    }else{
      this.fileExtension = false;
    }
    console.log("fileExtension", this.fileExtension);

    // this.filesToUpload = <Array<File>>$event.target.files;
    // this.canRevert = false;
    setTimeout(() => {
      if ($event.target.files[0] == undefined) {
        this.poaFileName = "";
        this.documentManagementID = null;
      }
      $event = null;
    }, 1000);
  }

  makeFileRequest(url: string, params: Array<string>, files: Array<File>) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      var now = Date.now();
      for (var i = 0; i < files.length; i++) {
        var name = now + '-' + files[i].name.replace(',', '');
        name = name.replace(new RegExp('\\(', 'g'), '');
        name = name.replace(new RegExp('\\)', 'g'), '');
        formData.append("file", files[i], name);
        this.FileOrignalName = files[i].name.replace(',', '');

        this.changedName = name;
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }

  upload() {
    var file = this.filesToUpload;
    return this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      if (result) {
        var document = {
          "DocumentManagement": {
            "DocumentName": Date.now() + " - Document (Power Of Attorney)",
            "DateOfDocument": new Date(),
            "CompletedDate": null,
            "MeetingTypeID": null,
            "ParentDocumentTypeID": null,
            "ParentSubDocumentTypeID": null,
            "DirectorKmp": "None",
            "DirectorID": null,
            "KMPID": null,
            "Remarks": "",
            "Overwrite": false,
            "Upload": this.changedName,
            "OriginalFileName": this.FileOrignalName,
            "FilePath": "",
            "CreatedBy": null,
            "CreatedDate": new Date(),
            "LastUpdateFiles": new Date(),
            "ModifiedBy": null,
            "ModifiedDate": null,
          }
        }
        return this.documentManagementMasterService.addDocumentManagement(document)
          .toPromise().then(res => { return Promise.resolve(res); })

      }
    }, (error) => {
      this.alert.error("Oops something went wrong");
      return false;
    });
  }

  showFormEntry() {
   
    this.disabledOnclick = true;
    var self = this;
    console.log("remarks ", self.poaForm.controls.remarks.value);
    if (this.filesToUpload != undefined && this.filesToUpload.length > 0) {
      this.upload().then(function (response:any) {
        if (response.status == 0) {

         
          var object = {
            paticularsofPower: self.poaForm.controls.paticularsofPower.value,
            namedesgnPower: self.poaForm.controls.namedesgnPower.value,
            dobminPower: self.setDate(self.poaForm.controls.dobminPower.value),
            commonsealaffixedPower: self.poaForm.controls.commonsealaffixedPower.value,
            datewithdrawalPower: self.setDate(self.poaForm.controls.datewithdrawalPower.value),
            DocumentManagementID: response.result._id,
            UploadDate: new Date(),
            FileOrignalName: self.FileOrignalName,
            remarks: self.poaForm.controls.remarks.value
          }
          
          self.PowerofattorneyService.samplePoaRecord(object).subscribe(response => {
            console.log("response",response);
            self.disabledOnclick = false;
            if (response.status == 0) {
            
              self.alert.successWithOk(response.message, 'powerofattorneylist');
            } else {
             
              // self.alert.error(response.message);
              if(response.err_fields){
              self.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
              }
              else{
                self.alert.error(response.message);
              }



            }
          })

        }
        
      })
    } 
     else {
      self.disabledOnclick = true;
      var object = {
        paticularsofPower: self.poaForm.controls.paticularsofPower.value,
        namedesgnPower: self.poaForm.controls.namedesgnPower.value,
        dobminPower: self.setDate(self.poaForm.controls.dobminPower.value),
        commonsealaffixedPower: self.poaForm.controls.commonsealaffixedPower.value,
        datewithdrawalPower: self.setDate(self.poaForm.controls.datewithdrawalPower.value),
        DocumentManagementID: null,
        UploadDate: null,
        FileOrignalName: null,
        remarks: self.poaForm.controls.remarks.value
      }

      self.PowerofattorneyService.samplePoaRecord(object).subscribe(response => {
        console.log("response",response);
        self.disabledOnclick = false;
        if (response.status == 0) {
          self.alert.successWithOk(response.message, 'powerofattorneylist')
        } else {
          // self.alert.error(response.message);
        
          if(response.err_fields){
            self.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
            }
            else{
              self.alert.error(response.message);
            }

        }
      })
    }
  }

  getPoaById(id) {
    this.addBtn = false;
    this.PowerofattorneyService.getPoaDataById(id).subscribe(response => {
      if (response.status == 0) {
        var poaById = response.data[0];
        this.poaForm.controls.paticularsofPower.setValue(poaById.paticularsofPower);
        this.poaForm.controls.namedesgnPower.setValue(poaById.namedesgnPower);
        this.poaForm.controls.dobminPower.setValue(poaById.dobminPower);
        this.poaForm.controls.commonsealaffixedPower.setValue(poaById.commonsealaffixedPower);
        this.poaForm.controls.datewithdrawalPower.setValue(poaById.datewithdrawalPower);
        this.poaForm.controls.fileName.setValue(poaById.FileOrignalName);
        this.poaForm.controls.remarks.setValue(poaById.remarks);

        if (poaById.dobminPower != null) {
          let dt = new Date(this.setFormatDate(poaById.dobminPower));
          this.dobminPower = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }

        if (poaById.datewithdrawalPower != null) {
          let dt = new Date(this.setFormatDate(poaById.datewithdrawalPower));
          this.datewithdrawalPower = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }

        if (poaById.DocumentManagementID != null) {
          this.fileAvailable = true;
          this.canRevert = false;
          this.poaFileName = poaById.FileOrignalName;
          this.documentManagementID = poaById.DocumentManagementID;
        }
      }
    })
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  updatePoaDetails() {
    this.disabledOnclick = true;
    var self = this;
    if (this.filesToUpload != undefined && this.filesToUpload.length > 0) {
      this.upload().then(function (response:any) {
        if (response.status == 0) {
          var object = {
            paticularsofPower: self.poaForm.controls.paticularsofPower.value,
            namedesgnPower: self.poaForm.controls.namedesgnPower.value,
            dobminPower: self.setDate(self.poaForm.controls.dobminPower.value),
            commonsealaffixedPower: self.poaForm.controls.commonsealaffixedPower.value,
            datewithdrawalPower: self.setDate(self.poaForm.controls.datewithdrawalPower.value),
            // uploadPower: self.poaForm.controls.uploadPower.value,
            DocumentManagementID: response.result._id,
            UploadDate: new Date(),
            FileOrignalName: self.FileOrignalName,
            remarks: self.poaForm.controls.remarks.value
          }


          self.PowerofattorneyService.updatePoaData(object, self.editPoaId).subscribe(response => {
            console.log("response",response);
            self.disabledOnclick = false;
            if (response.status == 0) {
              self.alert.successWithOk(response.message, 'powerofattorneylist')
            } else {
              // self.alert.error(response.message);
             
              if(response.err_fields){
                self.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
                }
                else{
                  self.alert.error(response.message);
                }
            }
          })

        }
      })
    } else {
      self.disabledOnclick = true;
      var object = {
        paticularsofPower: self.poaForm.controls.paticularsofPower.value,
        namedesgnPower: self.poaForm.controls.namedesgnPower.value,
        dobminPower: self.setDate(self.poaForm.controls.dobminPower.value),
        commonsealaffixedPower: self.poaForm.controls.commonsealaffixedPower.value,
        datewithdrawalPower: self.setDate(self.poaForm.controls.datewithdrawalPower.value),
        DocumentManagementID: self.documentManagementID,
        FileOrignalName: self.poaFileName,
        UploadDate: new Date(),
        remarks: self.poaForm.controls.remarks.value
        // uploadPower: self.poaForm.controls.uploadPower.value,
      }

      self.PowerofattorneyService.updatePoaData(object, self.editPoaId).subscribe(response => {
        self.disabledOnclick = false;
        if (response.status == 0) {
          self.alert.successWithOk(response.message, 'powerofattorneylist')
        } else {
          // self.alert.error(response.message);
        
          if(response.err_fields){
            self.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
            }
            else{
              self.alert.error(response.message);
            }
        }
      })

    }
  }

  addFilesOnUpdate() {
    this.fileAvailable = false;
    this.canRevert = true;
    // this.filesToUpload = [];
    // this.poaFileName = "";
    // this.documentManagementID = null;
  }

  downloadCtcDoc(id) {
    // window.location.href = environment.pssUrl + this.downloadAllLink + id;
    window.location.href = environment.pssServerUrl + this.downloadAllLink + id + '/' + this.token;
  }
  revert() {
    this.canRevert = false;
    this.fileAvailable = true;
  }
  removeFile() {
    this.fileAvailable = false;
    this.filesToUpload = [];
    this.poaFileName = "";
    this.documentManagementID = null;
  }

  generateOutput() {
    var object = {
      id: this.editPoaId, 
      fromDate: null,
      toDate: null
    }
    this.PowerofattorneyService.generatePoaDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.editPoaId);
          setTimeout(function () {
            self.downloadPdfDocument(self.editPoaId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.PowerofattorneyService.downloadPoaFile(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.PowerofattorneyService.downloadPoaPdfFile(id, 'Single');
  }
}
